<script lang="ts" setup>
const { t } = useTranslation()
const authStore = useAuthStore()
</script>

<template>
  <div w="full">
    <IaHeading
      :level="3"
      as:="h2"
      font-700
    >
      {{ t('epaper.landingPage.heading.3') }}
    </IaHeading>
    <IaParagraph
      v-if="!authStore.isAuthenticated"
      mt-6
      font-400
    >
      {{ t('epaper.landingPage.paragraph.3') }}
    </IaParagraph>
    <IaHeading
      v-if="!authStore.isAuthenticated"
      :level="4"
      as="h3"
      class="mt-12 lt-sm:mt-6"
      font-700
    >
      {{ t('epaper.landingPage.heading.4') }}
    </IaHeading>
    <div
      v-if="authStore.isAuthenticated"
      flex="~ col lg:row v-center"
      class="items-center"
      justify="between"
      rounded-lg
      border="1px solid grey-200"
      w="full"
      mt-6
      p-6
    >
      <div>
        <IaHeading
          :level="4"
          font-500
          lt-sm:text-center
        >
          {{ t('epaper.landingPage.heading.5') }}
        </IaHeading>
        <IaParagraph
          mt-2
          font-400
          text-center
        >
          {{ t('epaper.landingPage.paragraph.4') }}
        </IaParagraph>
      </div>
      <IaNuxtLink to="/apofinder">
        <IaButton
          variant="primary"
          class="normal-case font-500 !lt-sm:w-full lt-sm:mt-4"
        >
          {{ t('epaper.landingPage.button.toPharmacy') }}
        </IaButton>
      </IaNuxtLink>
    </div>
  </div>
</template>
